export default __webpack_public_path__ + "static/media/solution-industry.c2c70720.png";